import { render, staticRenderFns } from "./BundleOffersContainer.vue?vue&type=template&id=1b729381&scoped=true"
import script from "./BundleOffersContainer.vue?vue&type=script&lang=js"
export * from "./BundleOffersContainer.vue?vue&type=script&lang=js"
import style0 from "./BundleOffersContainer.vue?vue&type=style&index=0&id=1b729381&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b729381",
  null
  
)

export default component.exports